module.exports = __webpack_public_path__ + "img/parallax-4.e4562786.jpg";